"use strict";
// TODO: come amministrare il fatto che in Article c'è sia price sia buy price?
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseArticle = void 0;
var Article_1 = require("../Article");
var PurchaseArticle = /** @class */ (function (_super) {
    __extends(PurchaseArticle, _super);
    function PurchaseArticle(params) {
        var _this = _super.call(this, params) || this;
        _this.purchaseEventId = params.purchaseEventId;
        _this.purchaseId = params.purchaseId;
        _this.ptProductId = params.ptProductId;
        _this.isVat = params.isVat;
        _this.newPrice = params.newPrice;
        _this.newQuantity = params.newQuantity;
        _this.priceLock = params.priceLock;
        return _this;
    }
    PurchaseArticle.prototype.copy = function () {
        return new PurchaseArticle(__assign(__assign({}, this.toPlainObject()), { purchaseEventId: this.purchaseEventId, purchaseId: this.purchaseId, ptProductId: this.ptProductId, isVat: this.isVat, newPrice: this.newPrice, newQuantity: this.newQuantity, priceLock: this.priceLock }));
    };
    PurchaseArticle.prototype.toPlainObject = function () {
        return __assign(__assign({}, _super.prototype.toPlainObject.call(this)), { purchaseEventId: this.purchaseEventId, purchaseId: this.purchaseId, ptProductId: this.ptProductId, isVat: this.isVat, newPrice: this.newPrice, newQuantity: this.newQuantity, priceLock: this.priceLock });
    };
    return PurchaseArticle;
}(Article_1.RichArticle));
exports.PurchaseArticle = PurchaseArticle;
//# sourceMappingURL=PurchaseArticle.js.map